<template>
  <div>
    <div v-if="buyShow" class="buy_wrapper">
      <h3 class="buy_title">您未订购应用，无法授权，请先订购应用。</h3>
      <p class="buy_item">
        <a href="https://c.tb.cn/Y4.XNAVC">一个月：15元</a>
      </p>
      <p class="buy_item">
        <a href="https://c.tb.cn/Y4.X96o7">一季度：32元</a>
      </p>
      <p class="buy_item">
        <a href="https://c.tb.cn/Y4.XOMxN">半年：64元</a>
      </p>
      <p class="buy_item">
        <a href="https://c.tb.cn/Y4.XMFjh">一年：128元</a>
      </p>
    </div>
    <div v-else class="pwd_container">
      <van-form @submit="handleSubmit">
        <van-tabs v-model="customActiveKey" @change="handleTabClick">
          <van-tab title="密码登陆">
            <van-field
              v-model="loginForm.username"
              placeholder="请输入手机号/用户名"
              class="field_item"
              autocomplete="new-password"
            />

            <van-field
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              class="field_item"
              autocomplete="new-password"
            />

            <div class="pwd_btn">
              <van-button
                round
                block
                type="info"
                native-type="submit"
                color="#F93244"
                :disabled="!loginForm.username || !loginForm.password"
              >
                确定
              </van-button>
            </div>
          </van-tab>
          <van-tab title="手机号登录">
            <van-field
              v-model="loginForm.username"
              placeholder="请输入手机号"
              autocomplete="new-password"
              class="field_item"
            />

            <van-field
              v-model="loginForm.code"
              placeholder="请输入验证码"
              autocomplete="new-password"
              class="field_item"
            >
              <template #button>
                <span class="code" @click="getCode" v-if="state.smsSendBtn">
                  获取验证码
                </span>
                <span v-else class="code2">
                  {{ '(' + state.time + 's)后重新发送' }}
                </span>
              </template>
            </van-field>

            <div class="pwd_btn">
              <van-button
                round
                block
                type="info"
                native-type="submit"
                color="#F93244"
                :disabled="!loginForm.username || !loginForm.code"
              >
                立即登录
              </van-button>
            </div>
          </van-tab>
        </van-tabs>
      </van-form>
    </div>
  </div>
</template>

<script>
import { sipSms, sipLogin, storeInsert } from '@api';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import Vue from 'vue';
import axios from 'axios';

export default {
  data() {
    return {
      buyShow: false,
      customActiveKey: 'tab1',
      loginForm: {
        username: '',
        password: '',
        code: ''
      },

      state: {
        time: 60,
        smsSendBtn: true
      },
      session: ''
    };
  },
  created() {
    // 授权有效时间 = 0
    if (this.$route.query.r2_expires_in === '0') {
      this.buyShow = true;
    } else {
      const token = Vue.ls.get(ACCESS_TOKEN);
      if (token) {
        this.handleStoreInsert(token);
      }
      // 从token中取session
      this.session = this.$route.query.refresh_token;
    }
  },
  methods: {
    handleTabClick(key) {
      this.customActiveKey = key;
      this.loginForm.username = '';
    },
    handleSubmit() {
      let data = {};
      if (this.customActiveKey == 0) {
        data = {
          username: this.loginForm.username,
          password: this.loginForm.password
        };
      } else {
        data = {
          username: this.loginForm.username,
          code: this.loginForm.code
        };
      }
      console.log(data);
      sipLogin(data)
        .then((res) => {
          if (res.success) {
            const data = res.data;
            const token = data.token;
            this.handleStoreInsert(token);
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => this.$toast.fail(err.msg));
    },
    getCode(e) {
      e.preventDefault();
      const { state, loginForm } = this;
      if (!loginForm.username.trim()) {
        return this.$toast.fail('请输入手机号');
      }
      if (!/^1[3456789]\d{9}$/.test(loginForm.username)) {
        return this.$toast.fail('请输入正确的手机号');
      }
      state.smsSendBtn = false;
      const interval = window.setInterval(() => {
        if (state.time-- <= 0) {
          state.time = 60;
          state.smsSendBtn = true;
          window.clearInterval(interval);
        }
      }, 1000);
      sipSms(loginForm.username, 2)
        .then((res) => {
          if (res.success) {
            this.$toast.success('验证码获取成功');
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          clearInterval(interval);
          state.time = 60;
          state.smsSendBtn = true;
          this.$toast.fail(err.msg);
        });
    },

    handleStoreInsert(token) {
      axios({
        method: 'post',
        url: '/api/shop/insert',
        headers: { Authorization: token },
        data: {
          code: this.$route.query.refresh_token,
          refresh_token: this.$route.query.refresh_token,
          refresh_token_timeout: this.$route.query.refresh_token_timeout,
          type: 'TAOBAO'
        }
      })
        .then((res) => {
          if (res.data.success) {
            this.$toast.success(res.data.msg);
            window.location.href = '/mobile/storeBind?index=0';
          } else {
            this.$toast.fail(res.data.msg);
            this.buyShow = true;
          }
        })
        .catch((err) => {
          this.$toast.fail('出错啦～');
        });
    }
  }
};
</script>
<style lang="less" scoped>
.buy_wrapper {
  padding-top: 46.667vw;
  text-align: center;
  .buy_title {
    font-size: 4.533vw;
    margin-bottom: 2.133vw;
  }
  .buy_item {
    margin-bottom: 1.6vw;
    font-style: 4.267vw;
  }
}
.pwd_container {
  padding: 19.733vw 0;
  .red {
    color: #f93244;
  }
  .title {
    padding-left: 4.267vw;
    font-size: 7.467vw;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8.533vw;
  }
  .field_item {
    height: 14.933vw;
    margin-bottom: 4.267vw;
    display: flex;
    align-items: center;
    font-size: 4.533vw;
    color: rgba(0, 0, 0, 0.25);
    .code {
      font-size: 4.533vw;
      color: #f93244;
      padding: 6px 10px;
    }
    .code2 {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .pwd_btn {
    padding: 24.533vw 4.267vw 5.333vw;
  }
}
/deep/ .van-field__control {
  font-size: 4.533vw;
}
</style>
